import React from "react";
import { Badge } from "@mantine/core";
import type { RacketType } from "../graphql";
import {
  RACKET_TYPE_LABELS,
  RACKET_TYPE_SHOWS_BADGE,
} from "../utils/racketType";

interface Props {
  racketType: RacketType;
}

const RacketTypeBadge: React.FC<Props> = ({ racketType }) =>
  RACKET_TYPE_SHOWS_BADGE[racketType] ? (
    <Badge size="sm" variant="light" ml="xs">
      {RACKET_TYPE_LABELS[racketType]}
    </Badge>
  ) : null;

export default RacketTypeBadge;
